<template>
  <SingleButtonLanguage
    :set-ref-button="(el) => (refButtonLanguage = el)"
    :is-open="isVisiblePopupLang"
    @click="setListTargetArea([area])"
  >
    <template #icon-handler>
      <p>{{ speakerNickname }}</p>
      <div class="flex-wrap">
        <h4
          class="semibold language-gradient"
          :class="{
            'indonesian-style': languageChosen?.code === 'id',
          }"
        >
          <template v-if="languageChosen?.code === 'id'"> Bahasa<br />Indonesia </template>
          <template v-else>
            {{ languageChosen?.name }}
          </template>
        </h4>
        <IconArrow />
      </div>
    </template>
  </SingleButtonLanguage>
</template>

<script setup lang="ts">
import { computed, inject, ref } from 'vue';

import SingleButtonLanguage from '@/components/domains/chat/chat-single/SingleButtonLanguage.vue';
import IconArrow from '@/components/icons/IconArrow.vue';
import { Language } from '@/types/common';
import { ij_currentPopupMicInput, ij_setListTargetArea } from '@/utils/injectionKeys.js';

const { languageChosen, area } = defineProps<{
  languageChosen: Language;
  area: string;
  speakerNickname: string;
}>();

const currentPopupMicInput = inject(ij_currentPopupMicInput, ref(''));
const setListTargetArea = inject(ij_setListTargetArea) as (listArea: string[]) => void;

const refButtonLanguage = ref<HTMLElement>();
const popupName = `language-${area}`;

// 언어 선택 드랍다운 보임 여부
const isVisiblePopupLang = computed((): boolean => {
  return currentPopupMicInput.value === popupName;
});
</script>

<style scoped lang="scss">
.flex-wrap {
  display: flex;
  align-items: center;
  gap: $size-xs;
  .icon {
    transform: rotate(180deg);
  }
}
:root[data-theme='dark'] {
  .flex-wrap {
    .icon {
      color: #fff;
    }
  }
}

.language-gradient {
  background: var(--font-gradient-language);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
}

::v-deep(.button-handler) {
  width: 7.5rem;
}

::v-deep(.icon-handler) {
  width: fit-content;
}

.indonesian-style {
  font-size: $font-size-psmall;
  line-height: 1;
  text-align: center;
  white-space: normal;
}
</style>
